import api from "../../services/api";
import { NotificationItem, PaginatedNotifications } from "../../types";

// Fetch paginated notifications
export const fetchNotifications = async (page: number = 1, limit: number = 10): Promise<PaginatedNotifications> => {
    const response = await api.get(`/notifications?page=${page}&limit=${limit}`);
    return response.data;
  };
  
  // Fetch unread notifications
  export const fetchUnreadNotifications = async (): Promise<NotificationItem[]> => {
    const response = await api.get(`/notifications/unread`);
    return response.data;
  };
  
  // Mark all notifications as read
  export const markAllAsRead = async (): Promise<{ message: string }> => {
    const response = await api.patch(`/notifications/mark-all-read`);
    return response.data;
  };
  
  // Mark a single notification as read
  export const markAsRead = async (id: number): Promise<{ message: string }> => {
    const response = await api.patch(`/notifications/${id}/mark-read`);
    return response.data;
  };